import type { GetStaticProps, GetStaticPaths } from 'next';
import {
  fetchBlogPosts,
  fetchCaseStudies,
} from '../../utils/api/fetchStrapiData';
import { CaseStudyView } from '../../views/caseStudy/CaseStudy';
import type { OtherCaseStudy } from '../../views/caseStudy/CaseStudy.types';

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const caseStudies = await fetchCaseStudies();
  const blogPosts = await fetchBlogPosts();
  const slug = params?.slug || '';

  const caseStudy = caseStudies.find((caseStudy) => caseStudy.slug === slug);

  const otherCaseStudies: OtherCaseStudy[] = [];
  const index = caseStudy ? caseStudies.indexOf(caseStudy) : 0;
  const prevIndex =
    index == 0 ? 1 : (index - 1 + caseStudies.length) % caseStudies.length;
  const nextIndex = index == 0 ? 2 : (index + 1) % caseStudies.length;

  caseStudies[prevIndex] &&
    otherCaseStudies.push({
      type: prevIndex > index ? 'previous' : 'more recent',
      data: caseStudies[prevIndex],
    });
  caseStudies[nextIndex] &&
    otherCaseStudies.push({
      type: nextIndex > index ? 'previous' : 'more recent',
      data: caseStudies[nextIndex],
    });

  return {
    props: { caseStudy, otherCaseStudies, blogPosts },
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  const caseStudies = await fetchCaseStudies();

  const filteredCaseStudies = caseStudies.filter((item) => item?.createPage);

  const paths = filteredCaseStudies.map((caseStudy) => ({
    params: { slug: caseStudy.slug },
  }));
  return {
    fallback: false,
    paths,
  };
};

export default CaseStudyView;
